import React, { useState, useCallback, useEffect } from 'react';
import { orgTypes } from '../../Constants';
import useApi from '../../api/useApi';

function CreateOrganization({ handleClose, notification, action, selectedProject, refreshList }) {
  const orgId = JSON.parse(sessionStorage.user).organization.id;
  const { userId } = JSON.parse(sessionStorage.user).user;
  const formModel = {
    projectName: '',
    shortName: '',
    organizationId: orgId,
    createdBy: userId,
    status: action === 'create' ? 'Active' : '',
    sourceAddress: {
      location: '',
      city: '',
      state: '',
      country: '',
      zip: '',
    },
    destinationAddress: {
      location: '',
      city: '',
      state: '',
      country: '',
      zip: '',
    },
  };

  const [formData, setFormData] = useState(formModel);
  const [{ isLoading, isError, data }, postData] = useApi();
  const [state, getDataForUpdate] = useApi();
  const [state2, updateData] = useApi();

  // useEffect(() => {
  //   const _formData = document.getElementById('form-data');
  //   _formData.setAttribute('autocomplete', 'off');
  // }, []);

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const handleSourceAddressChange = useCallback((e) =>
    setFormData({
      ...formData,
      sourceAddress: { ...formData.sourceAddress, [e.target.name]: e.target.value },
      destinationAddress: { ...formData.destinationAddress, [e.target.name]: e.target.value },
    })
  );
  // const handleDestinationAddressChange = useCallback((e) =>
  //   setFormData({
  //     ...formData,
  //     destinationAddress: { ...formData.destinationAddress, [e.target.name]: e.target.value },
  //   })
  // );
  useEffect(() => {
    if (action === 'update') {
      getDataForUpdate(`/project/${selectedProject}`, 'GET');
    }
  }, [action]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.status === 'InActive') {
      formData.isActive = false;
    } else {
      formData.isActive = true;
    }
    if (action === 'create') postData(`/project`, 'POST', formData);
    else updateData(`/project/${selectedProject}`, 'PATCH', formData);
  };

  // create response
  useEffect(() => {
    if (!isLoading && !isError && data) {
      setFormData({ ...formModel });
      notification('success', 'Project created successfully');
      handleClose();
      refreshList();
    }

    if (isError) {
      notification('error', data);
      // handleClose();
    }
  }, [isLoading, isError, data]);

  // getOrganization for update response
  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setFormData({
        ...state.data.project,
        sourceAddress: {
          ...state.data.project.sourceAddress,
          location: state.data.project.sourceAddress ? state.data.project.sourceAddress.locality : '',
        },
        destinationAddress: {
          ...state.data.project.destinationAddress,
          location: state.data.project.destinationAddress ? state.data.project.destinationAddress.locality : '',
        },
      });
    }
  }, [state]);

  // update response
  useEffect(() => {
    if (!state2.isLoading && !state2.isError && state2.data != null) {
      notification('success', `Project updated successfully.`);
      handleClose();
      refreshList();
    }
    if (state2.isError) {
      notification('error', state2.data);
      // handleClose();
    }
  }, [state2]);

  return (
    <div
      className="flex justify-center items-center h-full w-full z-20 fixed"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))', overflowY: 'scroll' }}
    >
      <div className={`bg-white w-2/4 px-5 pt-1 mobile_toggle relative top-${action === 'create' ? 0 : 8} rounded-2xl`}>
        <img
          src="assets/img/Close.svg"
          className="absolute top-5 right-4 h-3 cursor-pointer"
          alt=""
          onClick={handleClose}
        />

        <p className="font-bold text-sm text-textBlue1 border-b p-4">{action === 'create' ? 'New' : 'Edit'} Project</p>

        <form className="mt-6 mb-3 mx-10 flex flex-wrap" autoComplete="new-password" onSubmit={handleSubmit}>
          <div className="mt-4 w-2.25/5 relative">
            {/* <label htmlFor="projectName" className="inputLabel block absolute bg-white left-3 -top-2.5">
              Project
            </label> */}
            <input
              type="text"
              placeholder="Project"
              value={formData.projectName}
              name="projectName"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>
          <div className="w-1/10" />
          <div className="mt-4 w-2.25/5 relative">
            {/* <label htmlFor="shortName" className="block inputLabel absolute bg-white left-3 -top-2.5">
              Short Name
            </label> */}
            <input
              type="text"
              placeholder="Short Name"
              value={formData.shortName}
              name="shortName"
              autoComplete="off"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>

          {action === 'create' ? (
            ''
          ) : (
            <div className="mt-4 w-2.25/5 relative">
              {/* <label htmlFor="status" className="block inputLabel absolute bg-white left-3 -top-2.5">
                Status
              </label> */}
              <div className="inputLabelText px-4 py-2 focus:outline-none">
                <select
                  name="status"
                  placeholder="Status"
                  value={formData.status}
                  className="border-none w-full focus:outline-none text-sm  text-parameter border "
                  onChange={handleInputChange}
                >
                  <option value="Active" className="fy-4">
                    Active
                  </option>
                  <option value="InActive" className="fy-4">
                    InActive
                  </option>
                </select>
              </div>
            </div>
          )}
          {action !== 'create' && <div className="w-1/10" />}
          {/* <div className="flex w-1/2 items-center  my-3">
            <label htmlFor="projectName" className="block text-parameter w-1/3 text-sm">
              PROJECT
            </label>
            <input
              type="text"
              value={formData.projectName}
              name="projectName"
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleInputChange}
            />
          </div> */}

          {/* <div className="flex w-1/2 items-center">
            <label htmlFor="shortName" className="block text-parameter w-1/3 text-sm">
              SHORT NAME
            </label>
            <input
              type="text"
              value={formData.shortName}
              name="shortName"
              autoComplete="off"
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleInputChange}
            />
          </div> */}
          {/* <p className="mt-4 w-full text-xs font-bold">Source Address</p> */}
          <div className="mt-4 w-2.25/5 relative">
            {/* <label htmlFor="address" className="block inputLabel absolute bg-white left-3 -top-2.5">
              Address
            </label> */}
            <input
              type="text"
              placeholder="Location"
              value={formData.sourceAddress?.location}
              autoComplete="off"
              name="location"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleSourceAddressChange}
            />
          </div>
          <div className="w-1/10" />
          {/* <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="address" className="block text-parameter w-1/3 text-sm">
              ADDRESS
            </label>
            <input
              type="text"
              value={formData.sourceAddress?.location}
              autoComplete="new-password"
              name="location"
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleSourceAddressChange}
            />
          </div> */}

          {/* <div className="mt-4 w-2.25/5 relative">
            <label htmlFor="city" className="block inputLabel absolute bg-white left-3 -top-2.5">
              City
            </label>
            <input
              type="text"
              value={formData.sourceAddress?.city}
              autoComplete="new-password"
              name="city"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleSourceAddressChange}
            />
          </div> */}
          {/* <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="city" className="block text-parameter w-1/3 text-sm">
              CITY
            </label>
            <input
              type="text"
              value={formData.sourceAddress?.city}
              autoComplete="new-password"
              name="city"
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleSourceAddressChange}
            />
          </div> */}
          {/*
          <div className="mt-4 w-2.25/5 relative">
            <label htmlFor="state" className="block inputLabel absolute bg-white left-3 -top-2.5">
              State
            </label>
            <input
              type="text"
              name="state"
              autoComplete="new-password"
              value={formData.sourceAddress?.state}
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleSourceAddressChange}
            />
          </div>
          <div className="w-1/10" /> */}
          {/* <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="state" className="block text-parameter w-1/3 text-sm">
              STATE
            </label>
            <input
              type="text"
              name="state"
              autoComplete="new-password"
              value={formData.sourceAddress?.state}
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleSourceAddressChange}
            />
          </div> */}
          {/* <div className="mt-4 w-2.25/5 relative">
            <label htmlFor="country" className="block inputLabel absolute bg-white left-3 -top-2.5">
              Country
            </label>
            <input
              type="text"
              name="country"
              autoComplete="new-password"
              value={formData.sourceAddress?.country}
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleSourceAddressChange}
            />
          </div> */}
          {/* <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="country" className="block text-parameter w-1/3 text-sm">
              COUNTRY
            </label>
            <input
              type="text"
              name="country"
              autoComplete="new-password"
              value={formData.sourceAddress?.country}
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleSourceAddressChange}
            />
          </div> */}
          {/* <div className="mt-4 w-2.25/5 relative">
            <label htmlFor="zip" className="block inputLabel absolute bg-white left-3 -top-2.5">
              Zipcode
            </label>
            <input
              type="text"
              name="zip"
              autoComplete="new-password"
              value={formData.sourceAddress?.zip}
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleSourceAddressChange}
            />
          </div> */}
          {/* <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="zip" className="block text-parameter w-1/3 text-sm">
              ZIPCODE
            </label>
            <input
              type="text"
              name="zip"
              autoComplete="new-password"
              value={formData.sourceAddress?.zip}
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleSourceAddressChange}
            />
          </div> */}
          {/* <p className="mt-4 w-full text-xs font-bold">Destination Address</p>
          <div className="mt-4 w-2.25/5 relative">
            <label htmlFor="address" className="block inputLabel absolute bg-white left-3 -top-2.5">
              Address
            </label>
            <input
              type="text"
              name="location"
              autoComplete="new-password"
              value={formData.destinationAddress?.location}
              className="inputLabelText px-4 py-2 focus:outline-none "
              onChange={handleDestinationAddressChange}
            />
          </div>
          <div className="w-1/10" /> */}
          {/* <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="address" className="block text-parameter w-1/3 text-sm">
              ADDRESS
            </label>
            <input
              type="text"
              value={formData.destinationAddress?.location}
              name="location"
              autoComplete="new-password"
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleDestinationAddressChange}
            />
          </div> */}
          {/* <div className="mt-4 w-2.25/5 relative ">
            <label htmlFor="city" className="block inputLabel absolute bg-white left-3 -top-2.5">
              City
            </label>
            <input
              type="text"
              autoComplete="new-password"
              value={formData.destinationAddress?.city}
              name="city"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleDestinationAddressChange}
            />
          </div> */}

          {/* <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="city" className="block text-parameter w-1/3 text-sm">
              CITY
            </label>
            <input
              type="text"
              autoComplete="new-password"
              value={formData.destinationAddress?.city}
              name="city"
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleDestinationAddressChange}
            />
          </div> */}
          {/* <div className="mt-4 w-2.25/5 relative">
            <label htmlFor="state" className="block inputLabel absolute bg-white left-3 -top-2.5">
              State
            </label>
            <input
              type="text"
              autoComplete="new-password"
              name="state"
              value={formData.destinationAddress?.state}
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleDestinationAddressChange}
            />
          </div>
          <div className="w-1/10" /> */}
          {/* <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="state" className="block text-parameter w-1/3 text-sm">
              STATE
            </label>
            <input
              type="text"
              autoComplete="new-password"
              name="state"
              value={formData.destinationAddress?.state}
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleDestinationAddressChange}
            />
          </div> */}
          {/* <div className="mt-4 w-2.25/5 relative">
            <label htmlFor="country" className="block inputLabel absolute bg-white left-3 -top-2.5">
              Country
            </label>
            <input
              type="text"
              autoComplete="new-password"
              name="country"
              value={formData.destinationAddress?.country}
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleDestinationAddressChange}
            />
          </div> */}
          {/* <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="country" className="block text-parameter w-1/3 text-sm">
              COUNTRY
            </label>
            <input
              type="text"
              autoComplete="new-password"
              name="country"
              value={formData.destinationAddress?.country}
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleDestinationAddressChange}
            />
          </div> */}

          {/* <div className="mt-4 w-2.25/5 relative">
            <label htmlFor="zip" className="block inputLabel absolute bg-white left-3 -top-2.5">
              Zipcode
            </label>
            <input
              type="text"
              autoComplete="new-password"
              name="zip"
              value={formData.destinationAddress?.zip}
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleDestinationAddressChange}
            />
          </div> */}
          {/* <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="zip" className="block text-parameter w-1/3 text-sm">
              ZIPCODE
            </label>
            <input
              type="text"
              autoComplete="new-password"
              name="zip"
              value={formData.destinationAddress?.zip}
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleDestinationAddressChange}
            />
          </div> */}
          {/* {action === 'create' ? '' : <div className="flex w-1/2 items-center  my-3.5" />}
          {action === 'create' ? (
            ''
          ) : (
            <div className="flex w-1/2 items-center my-3.5">
              <label htmlFor="role" className="block text-parameter w-1/3 text-sm">
                STATUS
              </label>

              <div className="rounded-lg bg-white px-2 py-3 focus:outline-none text-sm  text-parameter border w-1/2 h-10">
                <select
                  name="status"
                  value={formData.status}
                  className="border-none w-full focus:outline-none text-sm  text-parameter border "
                  onChange={handleInputChange}
                >
                  <option value="Active" className="fy-4">
                    Active
                  </option>
                  <option value="InActive" className="fy-4">
                    InActive
                  </option>
                </select>
              </div>
            </div>
          )} */}

          <div className="w-full relative -right-8 mb-2 mt-4">
            {state2.isLoading || isLoading ? (
              <div className="flex text-xs">
                <img src="assets/img/loader.svg" className="w-16 right-28 mx-auto" alt="" />
              </div>
            ) : (
              <div className="flex text-xs w-1/2 ml-auto">
                <button
                  type="submit"
                  onClick={() => handleClose()}
                  className="rounded-3xl border focus:outline-none w-1/2 h-10 mr-3 cursor-pointer font-semibold text-role"
                  // style={{ border: '1px solid #16406D' }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="rounded-3xl focus:outline-none w-1/2 h-10 text-white bg-btnBg cursor-pointer font-semibold"
                  style={{ border: '1px solid #16406D' }}
                >
                  Save
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateOrganization;
